<div>
  <div
    class="form-grid prices"
    *ngFor="let price of pricesForm.controls"
    [formGroup]="price"
  >
    <vdr-form-field
      [label]="
        ('catalog.price' | translate) +
        (1 < pricesForm.length ? ' (' + price.value.currencyCode + ')' : '')
      "
      for="price"
    >
      <div class="price-wrapper">
        <vdr-currency-input
          name="price"
          [currencyCode]="price.value.currencyCode"
          formControlName="price"
          (valueChange)="changePriceCurrency(price.value.currencyCode,$event)"
        />
        <div *ngIf="1 < pricesForm.controls.length">
          <button
            class="button-small delete-button"
            type="button"
            (click)="delete(price.value.currencyCode)"
          >
            <clr-icon shape="trash"></clr-icon>
          </button>
        </div>
      </div>
    </vdr-form-field>
    <!-- <vdr-variant-price-detail
    [price]="price.value.price"
    [currencyCode]="price.value.currencyCode"
    [priceIncludesTax]="channelPriceIncludesTax$ | async"
    [taxCategoryId]="detailForm.get('taxCategoryId')!.value"
  /> -->
  </div>
  <!-- <vdr-variant-price-strategy-detail
  [channelPriceIncludesTax]="channelPriceIncludesTax$ | async"
  [channelDefaultCurrencyCode]="channelDefaultCurrencyCode"
  [variant]="variant"
/> -->
  <ng-container *ngIf="unusedCurrencyCodes$ | async as unusedCurrencyCodes">
    <div *ngIf="unusedCurrencyCodes.length">
      <vdr-dropdown>
        <button class="button mt-2" vdrDropdownTrigger>
          <clr-icon shape="plus"></clr-icon>
          {{ "catalog.add-price-in-another-currency" | translate }}
          <clr-icon shape="ellipsis-vertical"></clr-icon>
        </button>
        <vdr-dropdown-menu>
          <button
            vdrDropdownItem
            *ngFor="let currencyCode of unusedCurrencyCodes"
            (click)="addPriceInCurrency(currencyCode)"
          >
            {{ currencyCode | localeCurrencyName }}
          </button>
        </vdr-dropdown-menu>
      </vdr-dropdown>
    </div>
  </ng-container>
</div>
